/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* RTB OrderLine (Campaign) Configuration (RTB API v1.0.0) Deal configuration for an RTB order line (PLADV-2606). Heimdall supports multiple deals per order line, each with its own type and floor.
*/
export class V3DealConfig {
    'dealId'?: string;
    'dealType'?: string;
    'dealFloor'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "dealId",
            "baseName": "dealId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dealType",
            "baseName": "dealType",
            "type": "string",
            "format": ""
        },
        {
            "name": "dealFloor",
            "baseName": "dealFloor",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return V3DealConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

